angular.module('lf.desktop')

.directive('launchLfcInternalBrowser', function ($rootScope, helpers, preloadData, $parse) {
  return function (scope, el, attrs) {
    
	el.on('click', function(event) {
		var isLFC = preloadData.client.isLFC;
	    if(isLFC) {
	    	event.preventDefault();
	    	var href = attrs.href;
	    	var options = $parse(attrs.lfcBrowserOptions)(scope);
	    	var width = (typeof options != 'undefined' && typeof options.width != 'undefined') ? options.width : -1;
	    	var height = (typeof options != 'undefined' && typeof options.height != 'undefined') ? options.height : -1;
	    	var resize = (typeof options != 'undefined' && typeof options.resize != 'undefined') ? options.resize : -1;
	    	var modal = (typeof options != 'undefined' && typeof options.modal != 'undefined') ? options.modal : -1;
	    	helpers.utils.lfc.launchInternalLink(href, width, height, resize, modal);
	    }
	});
    
  }
});
